(($) => {
    $('a.fancybox').attr('data-fancybox', 'fancybox');
})(jQuery);
